import {
	FormPhoneNumber as FormPhoneNumberDS,
	type FormPhoneNumberProps as FormPhoneNumberPropsDS,
} from '@gov-design-system-ce/react-form';
import { useAppLanguage, useCountryCodes } from '@gov-nx/core/hooks';
import { MessageWrapper } from '../MessageWrapper';

type FormPhoneNumberProps = Omit<
	FormPhoneNumberPropsDS,
	'classNames' | 'messageWrapper' | 'children'
>;

export const PhoneNumberInput = (props: FormPhoneNumberProps) => {
	const { language } = useAppLanguage();
	const { getOptions } = useCountryCodes();

	return (
		<div className="phone-number-input">
			<FormPhoneNumberDS
				{...props}
				field={{ size: 'm', ...props.field }}
				controlGroup={{ color: 'neutral', ...props.controlGroup }}
				messageWrapper={MessageWrapper}>
				{getOptions(language).map((option) => (
					<option
						value={option.value}
						key={option.value}>
						{option.label}
					</option>
				))}
			</FormPhoneNumberDS>
		</div>
	);
};
